// extracted by mini-css-extract-plugin
export default {"container":"styles_container__44VIe","label":"styles_label__ytBGg"};